import React from "react";
// import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ThemeProvider } from "./ThemeContext";
import { LanguageProvider } from "./LangContext";
import { BrowserRouter } from "react-router-dom";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <BrowserRouter>
//     <ThemeProvider>
//       <LanguageProvider>
//         <App />
//       </LanguageProvider>
//     </ThemeProvider>
//   </BrowserRouter>
// );

import { createRoot, hydrateRoot } from "react-dom/client";

const rootElement = document.getElementById("root");

const app = (
  <BrowserRouter>
    <ThemeProvider>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </ThemeProvider>
  </BrowserRouter>
);

if (rootElement && rootElement.hasChildNodes()) {
  // Гидратация после пререндеринга (react-snap)
  hydrateRoot(rootElement, app);
} else if (rootElement) {
  // Обычный рендер (dev-режим и т.п.)
  createRoot(rootElement).render(app);
}
